import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMPANY_CENTER_ACTION_TYPE } from '../actions';

const initialState = {
  summary: { loading: false, error: null, data: null },
};

const companyCenterReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMPANY_CENTER_ACTION_TYPE.LOAD_SUMMARY_REQUEST:
        draft.summary.loading = true;
        draft.summary.error = null;
        break;

      case COMPANY_CENTER_ACTION_TYPE.LOAD_SUMMARY_SUCCESS:
        draft.summary.loading = false;
        draft.summary.error = null;
        draft.summary.data = payload;
        break;

      case COMPANY_CENTER_ACTION_TYPE.LOAD_SUMMARY_FAILURE:
        draft.summary.loading = false;
        draft.summary.error = payload;
        break;

      case COMPANY_CENTER_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default companyCenterReducer;
